<template>

  <form @submit.prevent="save()"
        @keyup="form.errors.clear($event.target.name)"
        @change="form.errors.clear($event.target.name)">

    <LoadingBar v-show="form.request" />

    <input ref="imageCrop" type="hidden" name="image_crop" value="">
    <input ref="imageCropExtension" type="hidden" name="image_crop_extension" value="">
    <input ref="imageBackup" type="hidden" name="image_backup" value="">
    <input type="hidden" name="entity_type" id="entity_type" value="motion">
    <input type="hidden" name="file_id" id="file_id" ref="fileId">

    <div class="set-after" :class="{'has-error': form.errors.has('image')}">
      <label for="image">Video thumbnail (700x250px minimum)</label>

      <span class="help-block"><strong>{{ form.errors.get('image') }}</strong></span>

      <div class="image-input">
        <input type="file"
               accept="image/png,image/jpeg"
               name="image"
               id="image"
               class="need-crop">

        <div class="image-cell"></div>
        <img id="cover_image" style="width: 175px; height: 100px; display: none;" data-rjs="2">

        <button data-indicator-input-name="image_crop"
                data-indicator-backup-name="image_backup"
                class="upload-image"
                type="button"
                :disabled="form.request">Upload Image
        </button>

        <strong></strong>
      </div>
    </div>

    <div class="set-after" :class="{'has-error': form.errors.has('title')}">
      <label for="title">Title</label>

      <span class="help-block"><strong>{{ form.errors.get('title') }}</strong></span>

      <input type="text"
             id="title"
             name="title"
             class="long-input"
             v-model="form.title"
             :disabled="form.request">
    </div>

    <div class="set-after" :class="{'has-error': form.errors.has('video_path')}">
      <label>Upload video</label>

      <span class="help-block"><strong>{{ form.errors.get('video_path') }}</strong></span>

      <UploadVideo
          input-name="video_path"
          :disabled="form.request"
          :url="routeUploadVideo"
          :name="form.video_name"
          v-model="form.video_path"
      />
    </div>

    <div class="set-after" :class="{'has-error': form.errors.has('description')}">
      <label>Description (not required)</label>

      <TextEditor id="text-editor"
                  :disabled="form.request"
                  v-model="form.description"
      />

      <span class="help-block"><strong>{{ form.errors.get('description') }}</strong></span>
    </div>

    <!--<div class="set-after" :class="{'has-error': form.errors.has('subjects')}">-->
      <!--<label class="checkbox-common-label">Subject (max - 2)</label>-->

      <!--<span class="help-block"><strong>{{ form.errors.get('subjects') }}</strong></span>-->

      <!--<label class="checkbox-label" v-for="subject in usingSubjects" :key="subject.id">-->
        <!--<input type="checkbox"-->
               <!--name="subjects"-->
               <!--:disabled="form.request"-->
               <!--v-model="subject.selected">{{ subject.title }}-->
      <!--</label>-->
    <!--</div>-->

    <!--<div class="set-after" :class="{'has-error': form.errors.has('filters')}">-->
      <!--<label class="checkbox-common-label">Style & Medium option (max - 2)</label>-->

      <!--<span class="help-block"><strong>{{ form.errors.get('filters') }}</strong></span>-->

      <!--<label class="checkbox-label" v-for="filter in usingFilters" :key="filter.id">-->
        <!--<input type="checkbox"-->
               <!--name="filters"-->
               <!--:disabled="form.request"-->
               <!--v-model="filter.selected">{{ filter.title }}-->
      <!--</label>-->
    <!--</div>-->

    <button :disabled="form.request" type="submit" class="big-purple-button">
      {{ isExists ? 'Update' : 'Add' }}
    </button>

  </form>

</template>

<script>
  import Form from './../helpers/form';
  import TextEditor from './TextEditor.vue';
  import UploadVideo from './UploadVideo.vue';
  import modal from './../services/modal';
  import helpers from './../mixins/helpers';

  export default {
    mixins: [helpers],

    props: {
      routeSave: {
        type: String
      },

      routeAfterSaving: {
        type: String
      },

      routeUploadVideo: {
        type: String
      },

      subjects: {
        type: Array
      },

      filters: {
        type: Array
      },

      motion: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },

    components: {
      TextEditor,
      UploadVideo
    },

    data() {
      return {
        form: new Form({
          title: '',
          type: this.getQueryParameterByName('type', 'individual_project'),
          image_crop: '',
          image_crop_extension: '',
          image_backup: '',
          video_path: '',
          description: '',
          subjects: [],
          filters: [],
          file_id: '',
          ...this.motion
        }),

        isExists: !!this.motion.id,

        usingSubjects: this.cloneArray(this.subjects.slice()),
        usingFilters: this.cloneArray(this.filters.slice()),
      };
    },

    mounted() {
      if (this.isExists) {
        $('#cover_image').attr('src', this.motion.imagePath);
        $('#cover_image').css('display', 'inline-block');
        $('.image-cell').css('display', 'none');

        $('#file_id').val(this.motion.fileId);
      }
    },

    methods: {
      save() {
        let method = this.isExists ? 'put' : 'post';

        this.prepareFormForRequest();

        this.form[method](this.routeSave).then(() => {
          modal
            .success({text: `Video successfully ${this.isExists ? 'updated' : 'created'}.`})
            .then(() => {
              location.href = this.routeAfterSaving;
            });
        });
      },

      prepareFormForRequest() {
        this.form.image_backup = this.$refs.imageBackup.value;
        this.form.image_crop = this.$refs.imageCrop.value;
        this.form.image_crop_extension = this.$refs.imageCropExtension.value;
        this.form.file_id = this.$refs.fileId.value;

        this.form.subjects = this.subjects
          .filter(subject => {
            return subject.selected
          })
          .map(subject => {
            return subject.id
          });

        this.form.filters = this.filters
          .filter(filter => {
            return filter.selected
          })
          .map(filter => {
            return filter.id
          });
      },
    }
  }
</script>
